<template>
    <input
        v-model="formattedValue"
        v-bind="$attrs"
        type="text"
        inputmode="decimal"
        class="input"
        :class="{ 'input--error': hasError }"
        @input="handleInput"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    />
</template>

<script>
export default {
    name: 'NumberInput',
    props: {
        value: {
            type: [Number, String],
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        decimals: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            formattedValue: this.value,
            inputValue: this.value,
        };
    },
    watch: {
        inputValue(newVal) {
            this.$emit('input', this.normalizeNumber(newVal));
        },
        value(newValue) {
            this.formattedValue = newValue;
            this.inputValue = newValue;
        },
    },
    mounted() {
        if (this.value) {
            this.formattedValue = this.$options.filters.formatAsNumber(
                this.value,
                this.decimals,
                'stripIfInteger',
                false
            );
        }
    },
    methods: {
        normalizeNumber(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }

            if (this.decimals > 0) {
                return parseFloat(value.toString().replace(',', '.'));
            }

            return parseInt(value, 10);
        },
        handleInput({ target }) {
            if (this.isValidNumber(target.value) || target.value === '') {
                this.inputValue = target.value;
                this.formattedValue = target.value;
            } else {
                this.formattedValue = this.inputValue;
            }
        },
        isValidNumber(value) {
            const regex = this.decimals > 0 ? /^\d+(\.\d*|,\d*)?$/ : /^\d*$/;

            return regex.test(value);
        },
    },
};
</script>
